import styled from 'styled-components';
import { device } from '../breakpoints';

type StyledShowcaseProps = {
    addBottomMargin: boolean;
};

export const StyledShowcase = styled.section`
    position: relative;
    margin-bottom: ${(props: StyledShowcaseProps) => (props.addBottomMargin ? '50px' : '0')};
`;

export const GridContainer = styled.div`
    clear: left;

    @media ${device.GteSmall} {
        display: flex;
        flex: 0 1 auto;
        flex-wrap: wrap;
        justify-content: space-between;
    }
`;
